import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
    selector: 'app-disclaimer-bar',
    imports: [],
    templateUrl: './disclaimer-bar.html',
    styleUrl: './disclaimer-bar.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisclaimerBarComponent {
    public readonly imageInput = input<string>('sprintpay-flex');
    public readonly image = computed(() => this.imageInput());
    public readonly imageConfigInput = input<{ width: number; height: number }>({
        width: 105,
        height: 16,
    });
    public readonly imageConfig = computed(() => this.imageConfigInput());
    public readonly textInput = input<string>('');
    public readonly text = computed(() => this.textInput());
}
